import React from "react";
import "./AITradeChecklist.css";

function AITradeChecklist() {
  const checklist = [
    { label: "Trend", detail: "Higher highs / higher lows", status: "pass", score: 95 },
    { label: "VWAP", detail: "Price holding above VWAP", status: "pass", score: 92 },
    { label: "Volume", detail: "Above average volume", status: "pass", score: 90 },
    { label: "MACD", detail: "Improving momentum", status: "warning", score: 76 },
    { label: "Higher Low", detail: "Pullback defended", status: "pass", score: 88 },
    { label: "Tape Reading", detail: "Buyers still active", status: "pass", score: 91 },
    { label: "Level 2", detail: "Bid support visible", status: "pass", score: 87 },
    { label: "Catalyst", detail: "News confirmed", status: "pass", score: 84 },
  ];

  const getIcon = (status) => {
    if (status === "pass") return "✅";
    if (status === "warning") return "⚠️";
    return "❌";
  };

  return (
    <div className="workspacePanel aiTradeChecklist">
      <div className="checklistHeader">
        <div>
          <span className="checklistEyebrow">Trade Quality Scan</span>
          <h3>🧠 AI Trade Checklist</h3>
        </div>

        <div className="checklistGrade">
          <strong>A+</strong>
          <span>Setup Grade</span>
        </div>
      </div>

      <div className="checklistGrid">
        {checklist.map((item) => (
          <div key={item.label} className={`checklistItem ${item.status}`}>
            <div className="checkIcon">{getIcon(item.status)}</div>

            <div className="checkContent">
              <div>
                <p>{item.label}</p>
                <strong>{item.score}%</strong>
              </div>

              <small>{item.detail}</small>

              <div className="checkBar">
                <i style={{ width: `${item.score}%` }}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="checklistSummary">
        <div>
          <span>Overall Setup</span>
          <strong>🟢 Ready Watchlist</strong>
        </div>

        <p>Wait for confirmation candle before entry. Do not chase momentum.</p>
      </div>
    </div>
  );
}

export default AITradeChecklist;